import { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function PageHeader({ title, description, action }: PageHeaderProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 lg:flex-row lg:flex-wrap lg:items-start lg:justify-between">
      <div className="min-w-0 w-full lg:flex-1">
        <h1 className="text-2xl font-bold text-foreground break-words">{title}</h1>
        {description && (
          <p className="mt-1 text-muted-foreground">{description}</p>
        )}
      </div>
      {action && (
        <div className="min-w-0 w-full max-w-full lg:w-auto lg:max-w-none lg:flex-shrink-0">
          {action}
        </div>
      )}
    </div>
  );
}
